<template>
<main-content>
<kt-panel>
    <kt-panel-body id="address_repeater">
        <kt-form-section data-repeater-list="addresses">
            <kt-row data-repeater-item :style="{display: 'none'}">
                <kt-form-group class="col-12 col-sm-4 col-md-3">
                    <kt-form-label for="postal_code">
                        {{ $t('label.postal_code') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        data-id="0"
                        name="postal_code"
                    >
                    </kt-form-control>
                </kt-form-group>
                
                <kt-form-group class="col-12 col-sm-8 col-md-7">
                    <kt-form-label for="address">
                        {{ $t('label.address') }}
                    </kt-form-label>
                    <kt-form-control
                        data-id="0"
                        name="address"
                    >
                    </kt-form-control>
                </kt-form-group>
            
                <div class="col-12 col-sm-12 col-md-2" :style="{marginTop:'2.1rem'}">
                    <a data-repeater-delete class="w-100 btn btn-label-danger btn-bold">
                        <i class="la la-trash-o"></i>
                        {{ $t('btn.delete') }}
                    </a>
                </div>
            </kt-row>


            <kt-row v-for="address in addresses" v-bind:key="address.id" hor data-repeater-item>
                <kt-form-group class="col-12 col-sm-4 col-md-3">
                    <kt-form-label for="postal_code">
                        {{ $t('label.postal_code') }}
                    </kt-form-label>
                    <kt-form-control
                        :data-id="address.id" :value="address.postal_code"
                        dir="ltr"
                        name="postal_code"
                    >
                    </kt-form-control>
                </kt-form-group>
                
                <kt-form-group class="col-12 col-sm-8 col-md-7">
                    <kt-form-label for="address">
                        {{ $t('label.address') }}
                    </kt-form-label>
                    <kt-form-control
                        :data-id="address.id" :value="address.address"
                        name="address"
                    >
                    </kt-form-control>
                </kt-form-group>
            
                <div class="col-12 col-sm-12 col-md-2 m-auto">
                    <a data-repeater-delete class="w-100 btn btn-label-danger btn-bold">
                        <i class="la la-trash-o"></i>
                        {{ $t('btn.delete') }}
                    </a>
                </div>
            </kt-row>
        </kt-form-section>
         <div>
<!--          <p class="py-2 badge badge-danger"> برای ثبت درگاه پرداخت یاری کد پستی که وارد میشود همان کد پستی سامانه مالیات باشد</p>-->
         </div>
        <kt-form-group hor>
            <a data-repeater-create class="btn btn-bold btn-sm btn-label-brand">
                <i class="la la-plus"></i> {{ $t('btn.add') }}
            </a>
        </kt-form-group>

        <kt-form-action class="row mt-4">
            <button class="btn btn-md btn-success btn-wide" @click="submitForm" id="submit_btn">
                {{ $t('btn.update') }}
            </button>
        </kt-form-action>
    </kt-panel-body>
</kt-panel>
</main-content>
</template>

<script>
import mainContent from './Base'
import $ from 'jquery'
import { addressService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import Inputmask from 'inputmask'
import PostalCodes from 'postal-codes-js'
import { KTApp } from '@/plugins/core/app'

window.jQuery = $
require('jquery.repeater')

export default {
    components: {
        'main-content': mainContent
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('address/fetch')
            vm.$store.dispatch('user/fetchCurrent')
        })
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ])
    },
    mounted() {
        this.initial()
        //console.log(this.addresses)
    },
    methods: {
        initial() {
            $('#address_repeater').repeater({
                initEmpty: false,
            
                isFirstItemUndeletable: true,
                
                show: function () {
                    $(this).slideDown()
                    Inputmask('99999-99999').mask(document.querySelectorAll("#address_repeater input[name$='[postal_code]']"))
                },

                defaultValues: {
                    'text-input': null
                },

                hide: function (deleteElement) {                
                    $(this).slideUp(deleteElement);                 
                }   
            })

            Inputmask('99999-99999').mask(document.querySelectorAll("#address_repeater input[name$='[postal_code]']"))
        },
        submitForm(e) {
            let addresses = []
            let allow_to_sync = true
            let btn = $('#submit_btn')
            let submit_promise = new Promise((resolve, reject) => {
                $("#address_repeater input[name$='[address]']").map((index, item) => {
                    let postal_code_name = $(item).prop('name').replace('[address]', '[postal_code]')
                    let postal_code      =  $("input[name='"+postal_code_name+"']")
                    let postal_code_value = postal_code.prop('value')
                    
                    if(!postal_code_value) {
                        this.addValidationError(postal_code)
                        allow_to_sync = false
                    }else {
                        this.rmValidationError(postal_code)
                    }

                    let postal_code_is_not_valid = PostalCodes.validate('IR', postal_code_value.replace('-','')) !== true
                    if(postal_code_is_not_valid) {
                        this.addValidationError(postal_code, this.$t('validation.invalid_postal_code'))
                        allow_to_sync = false
                    }else {
                        this.rmValidationError(postal_code)
                    }
                    
                    if(!$(item).prop('value')) {
                        this.addValidationError(item)
                        allow_to_sync = false
                    }else {
                        this.rmValidationError(item)
                    }
                    
                    
                    postal_code_value 
                    && !postal_code_is_not_valid
                    && $(item).prop('value')
                    && addresses.push({
                        id: $(item).data('id'),
                        address: $(item).prop('value'),
                        postal_code: postal_code_value,
                    })
                    && (allow_to_sync = true)
                })

                resolve(addresses)
            })

            allow_to_sync && submit_promise.then(addresses => {
                KTApp.progress(btn)

                addressService.sync({
                    addresses: addresses
                }).then(response => {
                    KTApp.unprogress(btn)
                    this.showMsg($('#address_repeater'), 'success', response.data.message)

                }).catch(() => {
                    this.showMsg($('#address_repeater'), 'danger')
                    KTApp.unprogress(btn)
                }).finally(() => {
                    setTimeout( () => {
                        var URL = '/profile/addresses'
                        var Link = document.createElement('a');
                        Link.href = URL;
                        document.body.appendChild(Link);
                        Link.click();
                    }, 4000)
                })
            })
            
        },
        addValidationError(item, message = this.$t('validation.required')) {
            new Promise((resolve, reject) => {
                let elem = document.getElementById($(item).prop('name')+'-error')
                if(elem) {
                    elem.parentNode.removeChild(elem)
                }

                resolve()
            }).then(() => {
                let error_el = '<div id="'+$(item).prop('name')+'-error" class="d-block error invalid-feedback pl-1">'+message+'</div>'
                $(item).closest('.form-group').append(error_el)
            })
        },
        rmValidationError(item) {
            let elem = document.getElementById($(item).prop('name')+'-error')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }
        }
    }
}
</script>

<style>

</style>